import type { ReactNode } from "react";
import { useUserStore } from "@/views/stores";

export interface PermissionProps {
    /** 任一权限命中即可显示，兼容 Vue v-auth 的 codeList 语义。 */
    anyOf: string[];
    children: ReactNode;
    fallback?: ReactNode;
}

/** 按用户权限控制按钮、操作栏和局部功能的渲染。 */
export function Permission({ anyOf, children, fallback = null }: PermissionProps) {
    const permissions = useUserStore(state => state.userInfo.permissions || []);
    // 旧 v-auth 在按钮禁用/提示权限存在时保留入口，具体按钮仍由页面决定是否禁用。
    const hasSpecialButtonPermission = permissions.some(permission =>
        ["ROLE_BUTTON_BAN", "ROLE_BUTTON_TIP"].includes(permission)
    );
    const hasPermission = hasSpecialButtonPermission || anyOf.some(permission => permissions.includes(permission));
    return hasPermission ? children : fallback;
}

export default Permission;
